import { vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f951d2a")

_pushScopeId("data-v-3f951d2a")
const _hoisted_1 = { id: "hoverSettings" }
const _hoisted_2 = { class: "settings-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Show hovered component", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "settings-row" }, [
  /*#__PURE__*/_createVNode("p", null, " The Hover-Component is a Group-Component that can contain two components. The first one is the normal component and the second one will be displayed when hovered. ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.component.drawHovered = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.component.drawHovered]
      ]),
      _hoisted_3
    ]),
    _hoisted_4
  ]))
})